import { useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import SaveAndSubmit from "../Toolbars/components/SaveAndSubmit";
import AlertMessage from "../AlertMessage";
import { Form, Container, Row, Col } from "shards-react";
import { useRequestHook, useFormHook } from "../../utils/hooks/hooks";
import {
  updateExtractedFields,
  updateWorksteps,
} from "../../utils/redux/actions";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import ReactivateDocument from "./components/ReactivateDocument";
import SignatureFields from "../Toolbars/components/SignatureFields";
import DragAndDropTabs from "../Toolbars/components/DragAndDropTabs";

const SignatureDocToolbar = ({
  docId,
  fieldsNames,
  fieldDisplayNames,
  fieldTypes,
  extractedFields,
  dispatch,
  setFieldToBeUpdated,
  approved,
  pagesLength,
  worksteps,
  mandant,
  reactivationHandler,
}) => {
  const formRef = useRef(null);
  const [message, setMessage] = useState(false);
  const { handleRequest } = useRequestHook(); //request to send updated extracted-data in DB
  const [isNewEnvelope, setIsNewEnvelope] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [multiple] = useState(false);
  const [options, updateOptions] = useState([]);
  const [newExistingMessage, setNewExistingMessage] = useState(
    "Bitte wählen Sie eine bestehende Mappe aus oder erstellen Sie eine neue Mappe"
  );
  const [envelopeName, setEnvelopeName] = useState("");
  const [checkAllFields, setCheckAllFields] = useState(null);

  const formInputClasses = [];
  fieldsNames.map((field, index) => {
    switch (fieldTypes[index] || "text") {
      case "text":
        formInputClasses[field] = {
          delimiter: "",
        };
        break;
      case "number":
        formInputClasses[field] = {
          numeral: true,
          numeralThousandsGroupStyle: "none",
        };
        break;
      case "euro":
        formInputClasses[field] = {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          prefix: "€",
        };
        break;
      case "phone":
        formInputClasses[field] = {
          phone: true,
          phoneRegionCode: "DE",
          prefix: "",
        };
        break;
      default:
        formInputClasses[field] = {};
    }
  });

  const { handleSubmit } = useFormHook(() => {
    if (message) setMessage(false);
    let body = {
      docId,
      status: true,
      data: extractedFields,
      envelopeName,
      isNewEnvelope,
      pages: pagesLength,
    };
    if (worksteps) {
      body["worksteps"] = worksteps;
    }
    handleRequest("post", "/envelopes/add-or-create", body, (response) => {
      if (response) {
        window.location.reload();
      } else {
        setMessage({
          msg: "Fehler!",
        });
      }
    });
  });

  const handleWorkstepsChange = (_worksteps) => {
    dispatch(updateWorksteps(_worksteps));
  };

  const handleInputChange = (name, val, displayName, workstep_id) => {
    if (workstep_id !== undefined) {
      const idx = worksteps.findIndex((x) => x.workstep_id === workstep_id);
      const _worksteps = [...worksteps];
      if (idx !== -1) {
        _worksteps[idx][name] = val;
        dispatch(updateWorksteps(_worksteps));
      }
    } else {
      dispatch(
        updateExtractedFields({
          [name]: {
            ...extractedFields[name],
            word: val,
            displayName: displayName,
          },
        })
      );
    }
  };

  const modifyFieldValue = (e, displayName) => {
    e.preventDefault();
    const extractedValue = e.target.parentElement.previousElementSibling;

    extractedValue.focus(); // focus the input element

    setFieldToBeUpdated({
      fieldValue: e.target.attributes.getNamedItem("data-field").value,
      displayName: displayName,
    }); //set field to be updated

    if (document.querySelectorAll("area.selected"))
      document.querySelectorAll("area.selected").forEach((area) => {
        area.classList.remove("selected");
      }); //remove selected class if there is selected word
  };

  const submitHandler = () => {
    if (envelopeName === "") {
      setMessage({ msg: "Bitte Unterschriftenmappe auswählen / erstellen" });
      return;
    }
    if (worksteps && isNewEnvelope) {
      setCheckAllFields(1);
      return;
    }
    formRef.current.requestSubmit();
  };

  const makeAndHandleRequest = (q) => {
    return new Promise(function (resolve, reject) {
      let abort;
      handleRequest(
        "post",
        "/envelopes/autocomplete",
        {
          mandant: mandant,
          search: q,
        },
        (response) => (abort ? null : resolve(response))
      );
    });
  };

  const _handleSearch = (query) => {
    setIsLoading(true);
    makeAndHandleRequest(query).then((options) => {
      updateOptions(options);
      setIsLoading(false);
    });
  };

  const _selectChange = (val) => {
    if (val[0]) {
      val[0].customOption
        ? setNewExistingMessage("Neue Mappe erstellen")
        : setNewExistingMessage("zu bestehender Mappe hinzufügen");
      val[0].customOption
        ? setEnvelopeName(val[0].envname)
        : setEnvelopeName(val[0]);
      setIsNewEnvelope(val[0].customOption);
    } else {
      setEnvelopeName("");
      setIsNewEnvelope(true);
    }
  };

  useEffect(() => {
    /**
     * !!! Do not add logic !!!
     * Will be called only onComponentMount event.
     * Ser @lastname if empty string.
     * Update @fisrtname if needed.
     */

    if ("lastname" in extractedFields === true) return;
    if (!extractedFields?.firstname?.word) return;

    const [firstName, ...restNames] = extractedFields.firstname.word.split(" ");
    const lastName = restNames?.length
      ? restNames[restNames.length - 1]
      : firstName;

    dispatch(
      updateExtractedFields({
        firstname: {
          ...extractedFields.firstname,
          word: firstName,
        },
        lastname: {
          ...extractedFields.lastname,
          word: lastName,
        },
      })
    );
  }, []); //eslint-disable-line

  return (
    <Form innerRef={formRef} className="extracted-data" onSubmit={handleSubmit}>
      <Container className="modal-sign-env-container">
        <Row>
          <Col>
            <div className="d-flex justify-content-center text-uppercase text-light mb-2">
              <strong>Digitale Unterschrift</strong>
            </div>

            <AsyncTypeahead
              allowNew="true"
              isLoading={isLoading}
              multiple={multiple}
              options={options}
              id="async-example"
              labelKey="envname"
              minLength={2}
              onSearch={(e) => _handleSearch(e)}
              onChange={(v) => _selectChange(v)}
              placeholder="Unterschriftenmappe wählen / erstellen"
              promptText="Unterschriftenmappe wählen / erstellen"
              searchText="Suchen..."
              newSelectionPrefix="Neue Mappe erstellen: "
              emptyLabel="Keine Mappen gefunden"
            />
            <div className="d-flex justify-content-center text-light mt-2">
              {newExistingMessage}
            </div>
          </Col>
        </Row>
      </Container>
      {worksteps ? (
        <>
          <DragAndDropTabs
            worksteps={worksteps}
            handleWorkstepsChange={handleWorkstepsChange}
            fieldsNames={fieldsNames}
            isNewEnvelope={isNewEnvelope}
            extractedFields={extractedFields}
            fieldDisplayNames={fieldDisplayNames}
            formInputClasses={formInputClasses}
            handleInputChange={handleInputChange}
            approved={approved}
            modifyFieldValue={modifyFieldValue}
            checkAllFields={checkAllFields}
            setCheckAllFields={setCheckAllFields}
            setMessage={setMessage}
            formRef={formRef}
          />
        </>
      ) : (
        <SignatureFields
          fieldsNames={fieldsNames}
          isNewEnvelope={isNewEnvelope}
          extractedFields={extractedFields}
          fieldDisplayNames={fieldDisplayNames}
          formInputClasses={formInputClasses}
          handleInputChange={handleInputChange}
          approved={approved}
          modifyFieldValue={modifyFieldValue}
        />
      )}
      {message && (
        <AlertMessage
          autoDismiss
          alertMessage={message.msg}
          background={message.background}
          setMessage={setMessage}
        />
      )}
      {approved ? (
        <div className="d-flex justify-content-around">
          <ReactivateDocument reactivationHandler={reactivationHandler} />
        </div>
      ) : (
        <SaveAndSubmit
          submitText="Weiter"
          submitHandler={submitHandler}
          colclass="text-center p-0"
          xs_={12}
          sm_={12}
          md_={12}
        />
      )}
    </Form>
  );
};

const mapStateToProps = ({
  savedDocument: {
    id: docId,
    extractedFields,
    approved,
    pagesLength,
    worksteps,
  },
  userData: { mandant },
}) => {
  /**
   * Take the id, extractedFields and approved value of the document saved in redux and return it
   * in components props.
   */
  return {
    docId,
    extractedFields,
    approved,
    pagesLength,
    worksteps,
    mandant,
  };
};

export default connect(mapStateToProps)(SignatureDocToolbar); //Export component and connect it with redux.
